import gql from 'graphql-tag';

export const GET_LOCATION_PREDICTIONS = gql`
  query GoogleMapAddressSuggestions($gMapsInput: GMapsSuggestionInput) {
    GoogleMapAddressSuggestions(gMapsInput: $gMapsInput) {
      predictions {
        description
        matchedSubstrings {
          length
          offset
        }
        types
        reference
        placeID
        structuredFormatting {
          mainText
          secondaryText
        }
        terms {
          offset
          value
        }
      }
      status
    }
  }
`;
